import KyMethod from "./KyMethod"

export default class FAQRepo extends KyMethod {
  protected async getRawFAQList() {
    return this._getStrapiProtectedData("/faqs?populate=*")
  }
}
